import React, { useState } from "react";
import { FiSettings } from "react-icons/fi";
import { FaPen } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { auth } from "./FirebaseConfig"; // Import your Firebase auth
import { clearTokens } from "../utils/authService";

const Footer = ({ handleClick }) => {
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // Sign out from Firebase
      await auth.signOut();

      // Clear all auth tokens and cached data (including offline cache)
      clearTokens();
      
      // Navigate to login
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const handleWriteToUs = (e) => {
    e.preventDefault();
    
    // Email address
    const emailAddress = "enquiry@nexcard.co.in";
    const subject = "Customer Support Inquiry";
    const emailUrl = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}`;
    
    // Open the email client in a new window
    window.open(emailUrl, "_blank");
    
    // Fallback for mobile devices that might not have email client configured
    setTimeout(() => {
      window.location.href = emailUrl;
    }, 300);
    
    // If handleClick is provided, also call it
    if (handleClick) {
      handleClick("Writing to Support");
    }
  };

  return (
    <div className="footer">
      <div style={{ display: "flex", alignItems: "center" }}>
        <button className="btn" onClick={() => setShowLogout(!showLogout)}>
          <FiSettings className="btn-icon" /> Settings
        </button>
        {showLogout && (
          <button
            className="btn"
            onClick={handleLogout}
            style={{ marginLeft: "10px" }}
          >
            Logout
          </button>
        )}
      </div>
      <a 
        href="mailto:enquiry@nexcard.co.in?subject=Customer%20Support%20Inquiry"
        className="btn"
        onClick={handleWriteToUs}
        style={{ display: "inline-flex", alignItems: "center", textDecoration: "none" }}
      >
        <FaPen className="btn-icon" /> Write to Us
      </a>
    </div>
  );
};

export default Footer;